import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import createReducer from './reducers';
import * as analytics from './analytics/analytics';
import appSettings from './config/settings';
import { accountApi } from './ducks/accountApi';
import { boostApi } from './ducks/boostApi';
import { consentApi } from './ducks/consentApi';
import { identityApi } from './ducks/identity.duck';
import { notificationsApi } from './ducks/notifications.duck';
import { oneSignalApi } from './ducks/oneSignal.duck';
import { reportApi } from './ducks/reportApi';
import { savedSearchesApi } from './ducks/savedSearches.duck';
import { auth401Middleware } from './util/auth401Middleware';
import { notificationsPromptMiddleware } from './util/notificationsPromptMiddleware';

/**
 * Create a new store with the given initial state.
 * This adds default middleware (Redux Thunk) and analytics middleware from props.
 * Redux devTools are enabled in dev mode.
 */
export default function configureStore({
  initialState = {},
  sdk = null,
  analyticsHandlers = [],
  extraMiddlewares = [],
}) {
  const store = configureStoreReduxToolkit({
    reducer: createReducer(),
    preloadedState: initialState,
    middleware: getDefaultMiddleware => {
      const middlewares = getDefaultMiddleware({
        thunk: {
          extraArgument: sdk,
        },
        // Note: we do save class-based objects like UUIDs, Money, LatLng, LatLngBounds, Dates and Decimals to the store
        serializableCheck: false,
      }).prepend(analytics.createAnalyticsListenerMiddleware(analyticsHandlers).middleware);

      return middlewares.concat(
        accountApi.middleware,
        boostApi.middleware,
        consentApi.middleware,
        identityApi.middleware,
        notificationsApi.middleware,
        oneSignalApi.middleware,
        reportApi.middleware,
        savedSearchesApi.middleware,
        auth401Middleware,
        notificationsPromptMiddleware,
        extraMiddlewares
      );
    },
    devTools: appSettings.dev && typeof window === 'object',
  });

  return store;
}
